import { render, staticRenderFns } from "./InformationRed.vue?vue&type=template&id=4b994515&scoped=true&"
import script from "./InformationRed.vue?vue&type=script&lang=js&"
export * from "./InformationRed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b994515",
  null
  
)

export default component.exports